import React from "react";
import Link from "next/link";
import styles from "./counsellor_join.module.scss";

export const CounsellorJoin = () => {
  return (
    <section className={styles.section_mentor_join}>
      <div className="container">
        <div className={styles.wrapper}>
          <h2 className={styles.title}>Join with us as a Counsellor</h2>
          <p className={"font-medium"}>
            Consectetur adipiscing elit. Quam donec sapien id enim, fermentum,
            amet, rhoncus ac cursus. Et, tortor ullamcorper sit sed commodo
            turpis ullamcorper risus. Tincidunt in scelerisque donec neque
            tempor integer. Interdum justo metus malesuada nisi elit eget purus
            at non.
          </p>

          <div className={styles.btn_wrapper}>
            <Link legacyBehavior href="/partner-login">
              <a className={"btn btn-white btn-bg"}>Join Now</a>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CounsellorJoin;
